const soundEditionV1Abi = [
  {
    inputs: [],
    name: "ApprovalCallerNotOwnerNorApproved",
    type: "error"
  },
  {
    inputs: [],
    name: "ApprovalQueryForNonexistentToken",
    type: "error"
  },
  {
    inputs: [],
    name: "BalanceQueryForZeroAddress",
    type: "error"
  },
  {
    inputs: [],
    name: "ExceedsAddressBatchMintLimit",
    type: "error"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "available",
        type: "uint32"
      }
    ],
    name: "ExceedsEditionAvailableSupply",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidAmount",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidEditionMaxMintableRange",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidFundingRecipient",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidRandomnessLock",
    type: "error"
  },
  {
    inputs: [],
    name: "InvalidRoyaltyBPS",
    type: "error"
  },
  {
    inputs: [],
    name: "MaximumHasAlreadyBeenReached",
    type: "error"
  },
  {
    inputs: [],
    name: "MetadataIsFrozen",
    type: "error"
  },
  {
    inputs: [],
    name: "MintERC2309QuantityExceedsLimit",
    type: "error"
  },
  {
    inputs: [],
    name: "MintHasConcluded",
    type: "error"
  },
  {
    inputs: [],
    name: "MintRandomnessAlreadyRevealed",
    type: "error"
  },
  {
    inputs: [],
    name: "MintToZeroAddress",
    type: "error"
  },
  {
    inputs: [],
    name: "MintZeroQuantity",
    type: "error"
  },
  {
    inputs: [],
    name: "MintsAlreadyExist",
    type: "error"
  },
  {
    inputs: [],
    name: "NoAddressesToAirdrop",
    type: "error"
  },
  {
    inputs: [],
    name: "OwnerQueryForNonexistentToken",
    type: "error"
  },
  {
    inputs: [],
    name: "OwnershipNotInitializedForExtraData",
    type: "error"
  },
  {
    inputs: [],
    name: "TransferCallerNotOwnerNorApproved",
    type: "error"
  },
  {
    inputs: [],
    name: "TransferFromIncorrectOwner",
    type: "error"
  },
  {
    inputs: [],
    name: "TransferToNonERC721ReceiverImplementer",
    type: "error"
  },
  {
    inputs: [],
    name: "TransferToZeroAddress",
    type: "error"
  },
  {
    inputs: [],
    name: "URIQueryForNonexistentToken",
    type: "error"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "to",
        type: "address[]"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256"
      }
    ],
    name: "Airdropped",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "baseURI",
        type: "string"
      }
    ],
    name: "BaseURISet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toTokenId",
        type: "uint256"
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "ConsecutiveTransfer",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "contractURI",
        type: "string"
      }
    ],
    name: "ContractURISet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "tokens",
        type: "address[]"
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        indexed: false,
        internalType: "address",
        name: "caller",
        type: "address"
      }
    ],
    name: "ERC20Withdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "address",
        name: "caller",
        type: "address"
      }
    ],
    name: "ETHWithdrawn",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "editionCutoffTime_",
        type: "uint32"
      }
    ],
    name: "EditionCutoffTimeSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "editionMaxMintableLower_",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "editionMaxMintableUpper_",
        type: "uint32"
      }
    ],
    name: "EditionMaxMintableRangeSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "fundingRecipient",
        type: "address"
      }
    ],
    name: "FundingRecipientSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "metadataModule",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "baseURI",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "contractURI",
        type: "string"
      }
    ],
    name: "MetadataFrozen",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "metadataModule",
        type: "address"
      }
    ],
    name: "MetadataModuleSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "mintRandomnessEnabled_",
        type: "bool"
      }
    ],
    name: "MintRandomnessEnabledSet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantity",
        type: "uint256"
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256"
      }
    ],
    name: "Minted",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "bps",
        type: "uint16"
      }
    ],
    name: "RoyaltySet",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "edition_",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "symbol_",
        type: "string"
      },
      {
        indexed: false,
        internalType: "address",
        name: "metadataModule_",
        type: "address"
      },
      {
        indexed: false,
        internalType: "string",
        name: "baseURI_",
        type: "string"
      },
      {
        indexed: false,
        internalType: "string",
        name: "contractURI_",
        type: "string"
      },
      {
        indexed: false,
        internalType: "address",
        name: "fundingRecipient_",
        type: "address"
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "royaltyBPS_",
        type: "uint16"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "editionMaxMintableLower_",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "editionMaxMintableUpper_",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "editionCutoffTime_",
        type: "uint32"
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "flags_",
        type: "uint8"
      }
    ],
    name: "SoundEditionInitialized",
    type: "event"
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "ADDRESS_BATCH_MINT_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "ADMIN_ROLE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "METADATA_IS_FROZEN_FLAG",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "MINT_RANDOMNESS_ENABLED_FLAG",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]"
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256"
      }
    ],
    name: "airdrop",
    outputs: [
      {
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "editionCutoffTime",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "editionInfo",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "baseURI",
            type: "string"
          },
          {
            internalType: "string",
            name: "contractURI",
            type: "string"
          },
          {
            internalType: "string",
            name: "name",
            type: "string"
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string"
          },
          {
            internalType: "address",
            name: "fundingRecipient",
            type: "address"
          },
          {
            internalType: "uint32",
            name: "editionMaxMintable",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "editionMaxMintableUpper",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "editionMaxMintableLower",
            type: "uint32"
          },
          {
            internalType: "uint32",
            name: "editionCutoffTime",
            type: "uint32"
          },
          {
            internalType: "address",
            name: "metadataModule",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "mintRandomness",
            type: "uint256"
          },
          {
            internalType: "uint16",
            name: "royaltyBPS",
            type: "uint16"
          },
          {
            internalType: "bool",
            name: "mintRandomnessEnabled",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "mintConcluded",
            type: "bool"
          },
          {
            internalType: "bool",
            name: "isMetadataFrozen",
            type: "bool"
          },
          {
            internalType: "uint256",
            name: "nextTokenId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "totalBurned",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "totalMinted",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "totalSupply",
            type: "uint256"
          }
        ],
        internalType: "struct EditionInfo",
        name: "editionInfo",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "editionMaxMintable",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "editionMaxMintableLower",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "editionMaxMintableUpper",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "freezeMetadata",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "fundingRecipient",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      },
      {
        internalType: "address",
        name: "metadataModule_",
        type: "address"
      },
      {
        internalType: "string",
        name: "baseURI_",
        type: "string"
      },
      {
        internalType: "string",
        name: "contractURI_",
        type: "string"
      },
      {
        internalType: "address",
        name: "fundingRecipient_",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "royaltyBPS_",
        type: "uint16"
      },
      {
        internalType: "uint32",
        name: "editionMaxMintableLower_",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "editionMaxMintableUpper_",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "editionCutoffTime_",
        type: "uint32"
      },
      {
        internalType: "uint8",
        name: "flags_",
        type: "uint8"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "isMetadataFrozen",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "metadataModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256"
      }
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "fromTokenId",
        type: "uint256"
      }
    ],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [],
    name: "mintConcluded",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mintRandomness",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "mintRandomnessEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "nextTokenId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "numberBurned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "numberMinted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "royaltyBPS",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256"
      }
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "_approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string"
      }
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "contractURI",
        type: "string"
      }
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "editionCutoffTime_",
        type: "uint32"
      }
    ],
    name: "setEditionCutoffTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "editionMaxMintableLower_",
        type: "uint32"
      },
      {
        internalType: "uint32",
        name: "editionMaxMintableUpper_",
        type: "uint32"
      }
    ],
    name: "setEditionMaxMintableRange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "fundingRecipient",
        type: "address"
      }
    ],
    name: "setFundingRecipient",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "metadataModule",
        type: "address"
      }
    ],
    name: "setMetadataModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "mintRandomnessEnabled_",
        type: "bool"
      }
    ],
    name: "setMintRandomnessEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "bps",
        type: "uint16"
      }
    ],
    name: "setRoyalty",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalBurned",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalMinted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]"
      }
    ],
    name: "withdrawERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdrawETH",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];

export { soundEditionV1Abi };
